import PropTypes from 'prop-types';
import React, {Component} from 'react';
import moment from 'moment';
import DashboardApi from '../../../api/dashboard.jsx';
//Components
import Loader from '../loader.jsx';
import ClusteredBarChart from '../charts/clusteredBarChart.jsx';
import BarChart from '../charts/barChart.jsx';
import AdminOnly from 'ui/layout/AdminOnly';


//APIs

import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {makeCancelable} from 'helpers/cancelablePromise';
import events from 'lib/events';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

let SeasonMonths;

function updatePeriodForTimeframe(timeframe, record) {
  if (timeframe === 'week') {
    record.period = moment().day(record.periodNumber - 1).format('ddd');
  }

  if (timeframe === 'month') {
    record.period = moment().month(record.periodNumber - 1).format('MMM');
  }

  return record;
}

class SalesPerformance extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    start: PropTypes.any,
    end: PropTypes.any,
    branch: PropTypes.any,
    branches: PropTypes.array,
    timeframe: PropTypes.string.isRequired,
    branchesFull: PropTypes.any,
    dealer: PropTypes.object,
  };

  static defaultProps = {
    timeframe: 'month',
  };

  constructor(props) {
    super(props);
    this.state = {
      dealer: null,
      report: null,
      loaded: false,
      table: null,
    };
  }

  componentDidMount() {
    this.onUpdate();

    this.localeBind = events.subscribe('locale.changed', this.onUpdate);
  }

  componentDidUpdate(prevProps) {
    const {timeframe, branch} = this.props;

    if (prevProps.timeframe !== timeframe || prevProps.branch !== branch) {
      this.onUpdate();
    }
  }

  componentWillUnmount() {
    this.setState({
      report: null,
      loaded: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }

    if (this.localeBind && this.localeBind.remove) {
      this.localeBind.remove();
    }
  }

  onUpdate = () => {
    const {start, branch, branches, timeframe} = this.props;
    let newStart;
    let end = moment();
    let weeks = moment().weeks();
    let month = moment().month();
    let start2 = moment().subtract(1, 'year');
    let end2 = moment().subtract(1, 'year');

    if (timeframe === 'week') {
      newStart = start.startOf('day');
      end = end.endOf('isoweek').endOf('day');
      start2 = start2.weeks(weeks).startOf('isoweek').startOf('day');
      end2 = end2.weeks(weeks).endOf('isoweek').endOf('day');
    } else if (timeframe === 'month') {
      newStart = moment().startOf('year');
      end = moment().endOf('year');
      start2 = start2.startOf('year');
      end2 = end2.endOf('year');
    } else if (timeframe === 'year') {
      newStart = moment().startOf('year').subtract(5, 'year');
      end = moment().endOf('year');
      start2 = newStart;
      end2 = end;
    }
    this.setState({
      report: null,
      table: null,
      loaded: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }

    (this.fetching = makeCancelable(DashboardApi.getSalesPerformance(branch === -1 ? branches : branch,
      newStart, end, start2, end2, timeframe)))
      .then(data => {
        if (data) {
          for (let row in data) {
            if (data[row]) {
              data[row].thisYearTotal = typeof data[row].thisYearTotal === 'number' ?
                data[row].thisYearTotal.toFixed(2).toString() :
                data[row].thisYearTotal;
              data[row].lastYearTotal = typeof data[row].lastYearTotal === 'number' ?
                data[row].lastYearTotal.toFixed(2).toString() :
                data[row].lastYearTotal;
              data[row].total = typeof data[row].total === 'number' ?
                data[row].total.toFixed(2).toString() :
                data[row].total;
            }
          }
        }
        if (timeframe === 'month') {
          data = this.setLabelsColors(data);
        }
        this.setState({
          report: data.map(updatePeriodForTimeframe.bind(null, timeframe)),
          loaded: true,
        });
      }).catch(err => {
        console.log(err);
        this.setState({
          loaded: false,
        });
      });
  };

  getMonthsArray(from, to) {
    const timeValues = [];

    while (to > from) {
      timeValues.push(from.format('MMM').toLowerCase());
      from.add(1, 'month');
    }
    return timeValues;
  }

  setLabelsColors(data) {
    const newArray = [];

    SeasonMonths = !SeasonMonths ? this.getMonthsArray(this.props.dealer.seasonOpen, this.props.dealer.seasonClose) : SeasonMonths;
    data.forEach(function(element) {
      if (element.period && SeasonMonths.indexOf(element.period.toLowerCase()) >= 0) {
        element.labelColor = '#0088cc';
      } else {
        element.labelColor = '#000';
      }
      newArray.push(element);
    }, this);
    return newArray;
  }

  render() {
    const {report, loaded} = this.state;
    const {timeframe, start} = this.props;
    let {formatMessage} = this.props.intl;

    return <div className='total-water-analysis expanded-tile'>
      <Loader loaded={loaded}>
        <div className='row'>
          <div className='col-sm-12'>
            <div className='report-header'>
              <AdminOnly>
                <a className='dashboard-report-view-link pull-right'
                   href='#reports/sales/sales-performance'>
                  <span className='underline'><FormattedMessage id='general.view.report'/></span>
                  <i className='bl bl-right_arrow'/>
                </a>
              </AdminOnly>
              <h2 className='title'><FormattedMessage id='posdashboard.sales.vs.prior'/></h2>
              <hr/>
            </div>
          </div>
        </div>
        {report && report.length > 0 ?
          <div>
            <div className='row'>
              <div className='col-sm-12'>
                <div className='report-graph'>
                  {report ?

                    timeframe !== 'year' ?
                      <div>
                        <ClusteredBarChart data={report}
                                           verticalAxisTitle={formatMessage({id: 'posdashboard.bioguard.sales'}) + ' ($)'}
                                           colors={['#f4d033', '#93cb4d']}
                                           titleField='period'
                                           valueFields={['lastYearTotal', 'thisYearTotal']}
                                           balloonTexts={[
                                             formatMessage({id: 'posdashboard.sales.previous.year'}) + ': <b>$[[value]]</b>',
                                             formatMessage({id: 'posdashboard.sales.current.year'}) + ': <b>$[[value]]</b>',
                                           ]}
                                           fixedColumnWidth={25}
                                           fillAlphas={0.75}
                                           precision={2}
                        />
                        <div className='graph-legend'>
                          <span><i className='color-box light-yellow-box'/>{moment().subtract(1, 'year').format('YYYY')} </span>
                          <span><i className='color-box light-green-box'/>{moment().format('YYYY')} </span>
                        </div>
                      </div> :
                      <BarChart data={report}
                                verticalAxisTitle={formatMessage({id: 'posdashboard.bioguard.sales'}) + ' ($)'}
                                colors={['#93cb4d']}
                                titleField='period'
                                valueField='total'
                                balloonText={formatMessage({id: 'general.total.bioguard.sales'}) + ': <b>$[[value]]</b>'}
                                fixedColumnWidth={25}
                                fillAlphas={0.75}
                                precision={2}
                      /> :
                      <div/>
                  }
                </div>
              </div>
            </div>
          </div> :
          <div><FormattedMessage id='posdashboard.error.no.data'/></div>
        }
      </Loader>
    </div>;
  }
}

export default injectIntl(bindLocaleUpdate(SalesPerformance));
